import "react-toastify/dist/ReactToastify.css";
import { TitleWithDivider } from "@common/TitleWithDivider";
import pageHeaders from "@constants/PageHeaders";
import { UserPasswordResetForm } from "@components/Forms/UserPasswordResetForm";

const PasswordResetPage = () => {
  return (
    <>
      <div>
        <TitleWithDivider
          titleText={pageHeaders.USER.passwordChange}
          useDivider={true}
        />
        <UserPasswordResetForm></UserPasswordResetForm>
      </div>
    </>
  );
};

export default PasswordResetPage;
